/**
 * Helpers centralizados para resolução de imagens de gamificação.
 * Elimina duplicação entre Kiosk, Settings e outros componentes.
 */

/**
 * Resolve a imagem de uma conquista de frequência (attendance achievement).
 * Suporta URLs remotas (Firebase Storage) e assets locais.
 * @param {string} imageId - ID da imagem ou URL completa
 * @returns {string|null} - Caminho da imagem ou null
 */
export const getAttendanceImage = (imageId) => {
    if (!imageId) return null;
    if (imageId.startsWith('http')) return imageId;
    try {
        return require(`../../assets/images/attendance_achievements/${imageId}.png`);
    } catch (error) {
        return null;
    }
};

/**
 * Resolve a imagem de um nível de ranking (level rank).
 * Suporta URLs remotas (Firebase Storage) e assets locais.
 * @param {string} imageId - ID da imagem ou URL completa
 * @returns {string|null} - Caminho da imagem ou null
 */
export const getRankImage = (imageId) => {
    if (!imageId) return null;
    if (imageId.startsWith('http')) return imageId;
    try {
        return require(`../../assets/images/level_ranks/${imageId}.png`);
    } catch (error) {
        return null;
    }
};
